import { createStore } from "solid-js/store";
import { Show, onMount } from "solid-js";
import { loadAds, loadSemiFinalistsCms, setPageTitle, setSubMenu } from "../../app";

type State = {
    isContentReady: boolean;
}
export type Finalist = {
    SalonEntrantId: number;
    FirstName: string;
    LastName: string;
    Country: string;
    DVI: boolean;
    Teens: boolean;
}
export function SemiFinalistsPage() {
    const [state, setState] = createStore<State>({ isContentReady: false } as State);
    onMount(async () => {
        await loadSemiFinalistsCms();
        await loadAds("5th-arc-salon/semi-finalists");
        setSubMenu("Semi-Finalists");
        setPageTitle({ id: "5th-arc-salon/semi-finalists::title", text: "Semi-Finalists" });
        setState({ isContentReady: true });
    });
    return (
        <>
            <Show when={state.isContentReady}>
                <div class="text-content">
                    <div class="container">
                        <h1>
                            Semi-Finalists
                        </h1>
                        <p>
                            The large number of entrants in this year's competition caused us to create an additional tier of entrants we called "semi-finalists". While these artists were not selected to be recognized with further awards, we did want to express our appreciation for the high levels of skill they demonstrated and to encourage them to make submissions in future competitions. Their hard work and dedication are very much appreciated.
                        </p>
                        <ul class="icon multicolumns">
                            <li>
                                Shin-Young An
                            </li>
                            <li>
                                Imam Azhri
                            </li>
                            <li>
                                Justin Balliet
                            </li>
                            <li>
                                John Balsamo
                            </li>
                            <li>
                                Colleen Barry
                            </li>
                            <li>
                                Grandier Gil C. Bella
                            </li>
                            <li>
                                Kelly Borsheim
                            </li>
                            <li>
                                Richard Broderick
                            </li>
                            <li>
                                Dot Bunn
                            </li>
                            <li>
                                Ellen Buselli
                            </li>
                            <li>
                                Kenneth Cadwallader
                            </li>
                            <li>
                                Stephen Cefalo
                            </li>
                            <li>
                                Deborah Chabrian
                            </li>
                            <li>
                                Norman Choo
                            </li>
                            <li>
                                Christina Corkill
                            </li>
                            <li>
                                Rainie Crawford
                            </li>
                            <li>
                                Vishalandra Dakur
                            </li>
                            <li>
                                Marc Dalessio
                            </li>
                            <li>
                                Dmitri Danish
                            </li>
                            <li>
                                Gabriela G. Dellosso
                            </li>
                            <li>
                                Ric Dentinger
                            </li>
                            <li>
                                Grace DeVito
                            </li>
                            <li>
                                Nathan Drushinin
                            </li>
                            <li>
                                <a class="tape" target="_blank" href="/Artist/Index/7388">
                                    Stuart Dunkel
                                </a>
                            </li>
                            <li>
                                James Edmonds
                            </li>
                            <li>
                                James Fetter
                            </li>
                            <li>
                                <a class="tape" target="_blank" href="/Artist/Index/7385">
                                    Peter M. Fiore
                                </a>
                            </li>
                            <li>
                                Maryam Foroozanfar
                            </li>
                            <li>
                                Mossa Gabriele
                            </li>
                            <li>
                                Brendan Gargano
                            </li>
                            <li>
                                David Gluck
                            </li>
                            <li>
                                Mark Gonzales
                            </li>
                            <li>
                                Scott Grimando
                            </li>
                            <li>
                                Albert Handell
                            </li>
                            <li>
                                Russell Z. Harris
                            </li>
                            <li>
                                Claude B. Harvey
                            </li>
                            <li>
                                Thimgan Hayden
                            </li>
                            <li>
                                Steve Henderson
                            </li>
                            <li>
                                K. Henderson
                            </li>
                            <li>
                                Keewon Hong
                            </li>
                            <li>
                                Sultanul Islam
                            </li>
                            <li>
                                Joel Carson Jones
                            </li>
                            <li>
                                Darivse Kaleta
                            </li>
                            <li>
                                Andrea Kemp
                            </li>
                            <li>
                                Steven Kenny
                            </li>
                            <li>
                                Min Kim
                            </li>
                            <li>
                                B. Nicole Klassen
                            </li>
                            <li>
                                Richard Kochenash
                            </li>
                            <li>
                                Irena Korosec
                            </li>
                            <li>
                                Louis Lanzafama
                            </li>
                            <li>
                                <a class="tape" target="_blank" href="/Artist/Index/6606">
                                    Dana Levin
                                </a>
                            </li>
                            <li>
                                Mara Light
                            </li>
                            <li>
                                Jonathan Linton
                            </li>
                            <li>
                                Stuart T. Loughridge
                            </li>
                            <li>
                                <a class="tape" target="_blank" href="/Artist/Index/6615">
                                    Mark Lovett
                                </a>
                            </li>
                            <li>
                                Inga Loyev
                            </li>
                            <li>
                                Mike Magrath
                            </li>
                            <li>
                                Mike Malm
                            </li>
                            <li>
                                <a class="tape" target="_blank" href="/Artist/Index/2168">
                                    Ann James Massey
                                </a>
                            </li>
                            <li>
                                Katherine McNenly
                            </li>
                            <li>
                                Mark Meichelbock
                            </li>
                            <li>
                                Steve Mihal
                            </li>
                            <li>
                                <a class="tape" target="_blank" href="/Artist/Index/6982">
                                    Ann Morton
                                </a>
                            </li>
                            <li>
                                John Murray
                            </li>
                            <li>
                                Piotr Naliwajko
                            </li>
                            <li>
                                <a class="tape" taret="_blank" href="/Artist/Index/966">Juliette Aristides</a>
                            </li>
                            <li>
                                Teresa Nice
                            </li>
                            <li>
                                Bongkyun Noh
                            </li>
                            <li>
                                Helen Oh
                            </li>
                            <li>
                                Robert Palevitz
                            </li>
                            <li>
                                Kelly Phelps
                            </li>
                            <li>
                                Olga Plau
                            </li>
                            <li>
                                Susan Ploughe
                            </li>
                            <li>
                                David C. Powers
                            </li>
                            <li>
                                Elizabeth Pruitt
                            </li>
                            <li>
                                Aapo Pukk
                            </li>
                            <li>
                                Ricardo Quinonez
                            </li>
                            <li>
                                Osiris Rain
                            </li>
                            <li>
                                Elaine Rakowski
                            </li>
                            <li>
                                Pauline Roche
                            </li>
                            <li>
                                Bernadette Russo
                            </li>
                            <li>
                                <a class="tape" target="_blank" href="/Artist/Index/6613">
                                    Cesar Santos
                                </a>
                            </li>
                            <li>
                                Tristan Schane
                            </li>
                            <li>
                                Krista Schoening
                            </li>
                            <li>
                                Dan Schultz
                            </li>
                            <li>
                                Robert K. Semans
                            </li>
                            <li>
                                Claudia Seymour
                            </li>
                            <li>
                                Roxanne Skene
                            </li>
                            <li>
                                <a class="tape" target="_blank" href="/Artist/Index/6608">
                                    Dan Thompson
                                </a>
                            </li>
                            <li>
                                Melissa B. Tubbs
                            </li>
                            <li>
                                Line Tutwiler
                            </li>
                            <li>
                                Chris Waddell
                            </li>
                            <li>
                                Heather Ward
                            </li>
                            <li>
                                Jeffrey R. Watts
                            </li>
                            <li>
                                Lea Colie Wight
                            </li>
                            <li>
                                Kare Williams
                            </li>
                            <li>
                                Henry Wingate
                            </li>
                            <li>
                                Steve Worthington
                            </li>
                        </ul>
                    </div>
                </div>
            </Show>
        </>
    )
}